import { useMediaQuery } from "usehooks-ts";
import { useMemo } from "react";

export type DeviceType = "mobile" | "desktop";

interface Device {
  isMobile: boolean;
  isWeb: boolean;
  deviceType: DeviceType;
}

export const useDevice = (): Device => {
  const isMobile = useMediaQuery("(max-width: 899px)");

  return useMemo(
    () => ({
      isMobile,
      isWeb: !isMobile,
      deviceType: isMobile ? "mobile" : "desktop",
    }),
    [isMobile]
  );
};
